import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=6b964422&scoped=true&"
import script from "./inbox.vue?vue&type=script&lang=js&"
export * from "./inbox.vue?vue&type=script&lang=js&"
import style0 from "./inbox.vue?vue&type=style&index=0&id=6b964422&prod&scoped=true&lang=css&"
import style1 from "./inbox.vue?vue&type=style&index=1&id=6b964422&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b964422",
  null
  
)

export default component.exports